import * as yup from 'yup'

const schema = yup.object().shape({
  codigoBarras: yup.string(),
  idAnimal: yup.string().required('Campo obrigatório.').typeError('Selecione um animal válido.')
})

export default schema
